import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const ioLatencySchema: Schema = {
  title: 'Key IO Latency',
  level: 2,
  columns: commonColumns
}
